<template>
  <div id="app" @click="onAppClick">
    <transition name="fade">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer';
import { mapState } from 'vuex';

export default {
  name: 'app',
  components: {
    Footer
  },
  computed: {
    ...mapState([
      'menuDropdown',
      'projectDropdown',
    ])
  },
  data() {
    return {
      awesome: '8B6F43B9-43E6-43F0-9AE8-244B2B7CA5F2'
    };
  },
  methods: {
    onAppClick(event) {
      if (event.target.className.indexOf('dropdown-elem') === -1) {
        // hide dropdown
        //const $els = document.getElementsByClassName('miniNav');
        // TODO: check that miniNav is visible
        this.$store.dispatch('updateMenuDropdown', false);
        // TODO: check that fullNav is visible
        this.$store.dispatch('updateProjectDropdown', false);
      }
    }
  },
  mounted() {
    this.$store.dispatch('loadProjectList');
    document.addEventListener('click', this.onAppClick);
  },
  destroyed() {
    document.removeEventListener('click', this.onAppClick);
  }
};
</script>

<style lang="scss">
@import './assets/css/app';
</style>
